import { Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import Input from "../inputs/Input";
import {
  FormProvider,
  useForm,
} from "react-hook-form";
import { Address } from "../../pages/SignInPage";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import _ from "lodash";

type CreateAddressFormProps = {
  onSubmit?: (address: Address) => void;
  defaultValue?: Address;
};

export type CreateAddressFormHandler = {
  valid: () => Promise<boolean>;
  values: () => Address;
  isDirty: () => boolean;
}

const CreateAddressForm = forwardRef<CreateAddressFormHandler, CreateAddressFormProps>(({ defaultValue }, ref) => {
  const methods = useForm();
  useEffect(() => {
    if (defaultValue) {
      methods.reset({
        streetNumber: defaultValue.streetNumber,
        streetName: defaultValue.streetName,
        postalCode: defaultValue.postalCode,
        city: defaultValue.city,
        country: defaultValue.country,
        centerCode: defaultValue.centerCode,
      });
    }
  }, [methods, defaultValue]);

  useImperativeHandle(ref, () => ({
    valid: () => {
      return methods.trigger()
    },
    values: () => {
      return methods.getValues() as Address
    },
    isDirty: () => {
      return !_.isEqual(methods.getValues(), {
        streetNumber: "",
        streetName: "",
        postalCode: "",
        city: "",
        country: "",
        centerCode: "",
      })
    }
  }))

  return (
    <Flex w="100%">
      <FormProvider {...methods}>
        <form style={{ marginTop: "32px", width: "100%" }}>
          <Flex direction="column" gap="24px">
            <Flex gap="24px">
              <FormControl flexShrink={2} isInvalid={!!methods.formState.errors.streetNumber}>
                <Input
                  id="streetNumber"
                  placeholder="Numéro"
                  {...methods.register("streetNumber", {
                    required: "Ce champ est obligatoire",
                  })}
                ></Input>
                <FormErrorMessage>
                  <>{methods.formState.errors?.streetNumber?.message}</>
                </FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={!!methods.formState.errors.streetName}>
                <Input
                  id="streetName"
                  placeholder="Adresse de livraison"
                  {...methods.register("streetName", {
                    required: "Ce champ est obligatoire",
                  })}
                ></Input>
                <FormErrorMessage>
                  <>{methods.formState.errors?.streetName?.message}</>
                </FormErrorMessage>
              </FormControl>
            </Flex>
            <Flex gap="24px">
              <FormControl
                isInvalid={!!methods.formState.errors.postalCode}
                flexShrink={2}
              >
                <Input
                  id="postalCode"
                  placeholder="Code postal"
                  {...methods.register("postalCode", {
                    required: "Ce champ est obligatoire",
                  })}
                ></Input>
                <FormErrorMessage>
                  <>{methods.formState.errors?.postalCode?.message}</>
                </FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={!!methods.formState.errors.city}>
                <Input
                  id="city"
                  placeholder="Ville"
                  {...methods.register("city", {
                    required: "Ce champ est obligatoire",
                  })}
                ></Input>
                <FormErrorMessage>
                  <>{methods.formState.errors?.city?.message}</>
                </FormErrorMessage>
              </FormControl>
            </Flex>

            <FormControl isInvalid={!!methods.formState.errors.country}>
              <Input
                id="country"
                placeholder="Pays"
                {...methods.register("country")}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.country?.message}</>
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!methods.formState.errors.centerCode}>
              <Input
                id="centerCode"
                placeholder="Code centre (facultatif)"
                {...methods.register("centerCode")}
              ></Input>
              <FormErrorMessage>
                <>{methods.formState.errors?.centerCode?.message}</>
              </FormErrorMessage>
            </FormControl>

            {/* <Flex w="100%" justifyContent={"end"}>
              <Button onClick={handleSubmit}>
                {defaultValue == null && <><PlusIcon mr="8px"></PlusIcon>Ajouter l'adresse de livraison</>}
                {defaultValue != null && <><PenIcon mr="8px"></PenIcon>Enregistrer les modifications</>}
              </Button>
            </Flex> */}
          </Flex>
        </form>
      </FormProvider>
    </Flex>
  );
})

export default CreateAddressForm;
